import { render } from "./vmemberinviterecord.vue?vue&type=template&id=5150b2b0&scoped=true"
import script from "./vmemberinviterecord.vue?vue&type=script&lang=js"
export * from "./vmemberinviterecord.vue?vue&type=script&lang=js"

import "./vmemberinviterecord.vue?vue&type=style&index=0&id=5150b2b0&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5150b2b0"]])

export default __exports__